import { friendlyAssessmentNatureName, MetricNature } from '@upright/common/model/input/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { getIconAndColorByNature } from '@upright/ui/common/upright/core/impact-lenses/pais/common/icons';
import { CSSProperties } from 'react';
import styled from 'styled-components';

const natures = [MetricNature.DIRECT_DISCLOSURE, MetricNature.THIRD_PARTY_ASSESSMENT, MetricNature.UPRIGHT_ESTIMATE];

interface Props {
  style?: CSSProperties;
}

export function PaiLegend(props: Props) {
  const layout = useCarouselLayout();
  if (layout.fullArea().width > 600) {
    return (
      <Root style={props.style}>
        <Title>Legend</Title>
        {natures.map(nature => {
          const { Icon, color } = getIconAndColorByNature(nature);
          return (
            <Row key={nature}>
              <Icon style={{ stroke: color, width: '1.2em', height: '1.2em', marginRight: '0.6em' }} />
              {friendlyAssessmentNatureName(nature)}
            </Row>
          );
        })}
      </Root>
    );
  }
  return <></>;
}

const Root = styled.div`
  padding: 1em;
  width: 100%;
  max-width: 250px;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  border: 1px solid ${BouColor.TOOL_BORDER_LIGHT_GRAY};
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  & + & {
    margin-top: 1em;
  }
`;

const Title = styled.div`
  font-weight: 500;
  margin-bottom: 1.1em;
`;
